import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tl_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const assetUrl = (p) =>
  !p ? "" : /^https?:\/\//.test(p) ? p : `${BACKEND}${p}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || "Something went wrong. Please try again.";
};

export const telHref = (p) => "tel:" + String(p || "").replace(/[^0-9+]/g, "");
export const mapHref = (q) => "https://maps.google.com/?q=" + encodeURIComponent(q);
